var map = {
	"./Property 1=4x3, Property 2=AD - Andorra.svg": "e2a8",
	"./Property 1=4x3, Property 2=AE - United Arab Emirates.svg": "472c",
	"./Property 1=4x3, Property 2=AF - Afghanistan.svg": "2413",
	"./Property 1=4x3, Property 2=AG - Antigua and Barbuda.svg": "b33d1",
	"./Property 1=4x3, Property 2=AI - Anguilla.svg": "63f0",
	"./Property 1=4x3, Property 2=AL - Albania.svg": "43ef",
	"./Property 1=4x3, Property 2=AM - Armenia.svg": "dea5",
	"./Property 1=4x3, Property 2=AO - Angola.svg": "5d0f",
	"./Property 1=4x3, Property 2=AQ - Antarctica.svg": "2086",
	"./Property 1=4x3, Property 2=AR - Argentina.svg": "4566",
	"./Property 1=4x3, Property 2=AS - American Samoa.svg": "04d9",
	"./Property 1=4x3, Property 2=AT - Austria.svg": "cefd",
	"./Property 1=4x3, Property 2=AU - Australia.svg": "622e",
	"./Property 1=4x3, Property 2=AW - Aruba.svg": "208c",
	"./Property 1=4x3, Property 2=AX - Aland Islands.svg": "b7c6",
	"./Property 1=4x3, Property 2=AZ - Azerbaijan.svg": "8276",
	"./Property 1=4x3, Property 2=BA - Bosnia and Herzegovina.svg": "c478",
	"./Property 1=4x3, Property 2=BB - Barbados.svg": "b4ac",
	"./Property 1=4x3, Property 2=BD - Bangladesh.svg": "cb4a",
	"./Property 1=4x3, Property 2=BE - Belgium.svg": "d3a2",
	"./Property 1=4x3, Property 2=BF - Burkina Faso.svg": "3f60",
	"./Property 1=4x3, Property 2=BG - Bulgaria.svg": "5e53",
	"./Property 1=4x3, Property 2=BH - Bahrain.svg": "91cc",
	"./Property 1=4x3, Property 2=BI - Burundi.svg": "0cad",
	"./Property 1=4x3, Property 2=BJ - Benin.svg": "5871",
	"./Property 1=4x3, Property 2=BL - Saint Barthélemy.svg": "8279",
	"./Property 1=4x3, Property 2=BM - Bermuda.svg": "ff7b",
	"./Property 1=4x3, Property 2=BN - Brunei Darussalam.svg": "fb3b",
	"./Property 1=4x3, Property 2=BO - Bolivia.svg": "88ec",
	"./Property 1=4x3, Property 2=BQ - Bonaire Sint Eustatius and Saba.svg": "8455",
	"./Property 1=4x3, Property 2=BR - Brazil.svg": "16b7",
	"./Property 1=4x3, Property 2=BS - Bahamas.svg": "92e7",
	"./Property 1=4x3, Property 2=BT - Bhutan.svg": "93bf",
	"./Property 1=4x3, Property 2=BV - Bouvet Island.svg": "ed85",
	"./Property 1=4x3, Property 2=BW - Botswana.svg": "b98d",
	"./Property 1=4x3, Property 2=BY - Belarus.svg": "8457",
	"./Property 1=4x3, Property 2=BZ - Belize.svg": "a226",
	"./Property 1=4x3, Property 2=CA - Canada.svg": "013e",
	"./Property 1=4x3, Property 2=CC - Cocos (Keeling) Islands.svg": "523c",
	"./Property 1=4x3, Property 2=CD - DR Congo.svg": "0580",
	"./Property 1=4x3, Property 2=CF - Central African Republic.svg": "9498",
	"./Property 1=4x3, Property 2=CG - Republic of the Congo.svg": "dc4ad",
	"./Property 1=4x3, Property 2=CH - Switzerland.svg": "7ae9",
	"./Property 1=4x3, Property 2=CI - Côte d'Ivoire.svg": "04ef",
	"./Property 1=4x3, Property 2=CK - Cook Islands.svg": "d3ea",
	"./Property 1=4x3, Property 2=CL - Chile.svg": "989a",
	"./Property 1=4x3, Property 2=CM - Cameroon.svg": "eeb8",
	"./Property 1=4x3, Property 2=CO - Colombia.svg": "0612",
	"./Property 1=4x3, Property 2=CR - Costa Rica.svg": "6c12",
	"./Property 1=4x3, Property 2=CU - Cuba.svg": "bfa2",
	"./Property 1=4x3, Property 2=CV - Cape Verde.svg": "ef46",
	"./Property 1=4x3, Property 2=CW - Curaçao.svg": "bfba",
	"./Property 1=4x3, Property 2=CX - Christmas Island.svg": "aace",
	"./Property 1=4x3, Property 2=CY - Cyprus.svg": "05ac",
	"./Property 1=4x3, Property 2=CZ - Czech Republic.svg": "795b",
	"./Property 1=4x3, Property 2=DE - Germany.svg": "4322",
	"./Property 1=4x3, Property 2=DJ - Djibouti.svg": "38d3",
	"./Property 1=4x3, Property 2=DK - Denmark.svg": "d2db",
	"./Property 1=4x3, Property 2=DM - Dominica.svg": "e3cd",
	"./Property 1=4x3, Property 2=DO - Dominican Republic.svg": "bcbe",
	"./Property 1=4x3, Property 2=DZ - Algeria.svg": "7e53",
	"./Property 1=4x3, Property 2=EC - Ecuador.svg": "b711",
	"./Property 1=4x3, Property 2=EE - Estonia.svg": "32f8",
	"./Property 1=4x3, Property 2=EG - Egypt.svg": "c229",
	"./Property 1=4x3, Property 2=EH - SADR.svg": "192e",
	"./Property 1=4x3, Property 2=ER - Eritrea.svg": "8bfb",
	"./Property 1=4x3, Property 2=ES - Spain.svg": "bee9",
	"./Property 1=4x3, Property 2=ET - Ethiopia.svg": "5c4a",
	"./Property 1=4x3, Property 2=FI - Finland.svg": "b019",
	"./Property 1=4x3, Property 2=FJ - Fiji.svg": "a97b",
	"./Property 1=4x3, Property 2=FK - Falkland Islands.svg": "22a5",
	"./Property 1=4x3, Property 2=FM - Federated States of Micronesia.svg": "1c7a",
	"./Property 1=4x3, Property 2=FO - Faroe Islands.svg": "aab0",
	"./Property 1=4x3, Property 2=FR - France.svg": "53dc",
	"./Property 1=4x3, Property 2=GA - Gabon.svg": "a088",
	"./Property 1=4x3, Property 2=GB - United Kingdom.svg": "d9d5",
	"./Property 1=4x3, Property 2=GD - Grenada.svg": "dea4",
	"./Property 1=4x3, Property 2=GE - Georgia.svg": "aa43",
	"./Property 1=4x3, Property 2=GF - French Guiana.svg": "4926",
	"./Property 1=4x3, Property 2=GG - Guernsey.svg": "5d86",
	"./Property 1=4x3, Property 2=GH - Ghana.svg": "741d",
	"./Property 1=4x3, Property 2=GI - Gibraltar.svg": "7a12",
	"./Property 1=4x3, Property 2=GL - Greenland.svg": "5fc0",
	"./Property 1=4x3, Property 2=GM - Gambia.svg": "cb23",
	"./Property 1=4x3, Property 2=GN - Guinea.svg": "4723",
	"./Property 1=4x3, Property 2=GP - Guadeloupe.svg": "a34b",
	"./Property 1=4x3, Property 2=GQ - Equatorial Guinea.svg": "2c6e",
	"./Property 1=4x3, Property 2=GR - Greece.svg": "ab4e",
	"./Property 1=4x3, Property 2=GS - South Georgia and the South Sandwich Islands.svg": "0906",
	"./Property 1=4x3, Property 2=GT - Guatemala.svg": "aaf1",
	"./Property 1=4x3, Property 2=GU - Guam.svg": "86a7",
	"./Property 1=4x3, Property 2=GW - Guinea-Bissau.svg": "0a1f",
	"./Property 1=4x3, Property 2=GY - Guyana.svg": "5a3a",
	"./Property 1=4x3, Property 2=HK - Hong Kong.svg": "8b88",
	"./Property 1=4x3, Property 2=HM - Heard Island and McDonald Islands.svg": "1be3",
	"./Property 1=4x3, Property 2=HN - Honduras.svg": "fa3f",
	"./Property 1=4x3, Property 2=HR - Croatia.svg": "92d3",
	"./Property 1=4x3, Property 2=HT - Haiti.svg": "eb0a",
	"./Property 1=4x3, Property 2=HU - Hungary.svg": "d812",
	"./Property 1=4x3, Property 2=ID - Indonesia.svg": "27dd",
	"./Property 1=4x3, Property 2=IE - Ireland.svg": "08a1",
	"./Property 1=4x3, Property 2=IL - Israel.svg": "02d2",
	"./Property 1=4x3, Property 2=IM - Isle of Man.svg": "beb9",
	"./Property 1=4x3, Property 2=IN - India.svg": "5798",
	"./Property 1=4x3, Property 2=IO - British Indian Ocean Territory.svg": "a3de",
	"./Property 1=4x3, Property 2=IQ - Iraq.svg": "f554",
	"./Property 1=4x3, Property 2=IR - Iran.svg": "ab78",
	"./Property 1=4x3, Property 2=IS - Iceland.svg": "5db7",
	"./Property 1=4x3, Property 2=IT - Italy.svg": "a906",
	"./Property 1=4x3, Property 2=JE - Jersey.svg": "7383",
	"./Property 1=4x3, Property 2=JM - Jamaica.svg": "078f",
	"./Property 1=4x3, Property 2=JO - Jordan.svg": "b994",
	"./Property 1=4x3, Property 2=JP - Japan.svg": "c1a13",
	"./Property 1=4x3, Property 2=KE - Kenya.svg": "f59d",
	"./Property 1=4x3, Property 2=KG - Kyrgyzstan.svg": "0671",
	"./Property 1=4x3, Property 2=KH - Cambodia.svg": "c4c1",
	"./Property 1=4x3, Property 2=KI - Kiribati.svg": "9ca8",
	"./Property 1=4x3, Property 2=KM - Comoros.svg": "68c8",
	"./Property 1=4x3, Property 2=KN - Saint Kitts and Nevis.svg": "f0fa",
	"./Property 1=4x3, Property 2=KP - North Korea.svg": "b5d6",
	"./Property 1=4x3, Property 2=KR - South Korea.svg": "2efb",
	"./Property 1=4x3, Property 2=KW - Kuwait.svg": "e70c",
	"./Property 1=4x3, Property 2=KY - Cayman Islands.svg": "51c8",
	"./Property 1=4x3, Property 2=KZ - Kazakhstan.svg": "40de",
	"./Property 1=4x3, Property 2=LA - Laos.svg": "60e5",
	"./Property 1=4x3, Property 2=LB - Lebanon.svg": "6a6c",
	"./Property 1=4x3, Property 2=LC - Saint Lucia.svg": "164e",
	"./Property 1=4x3, Property 2=LI - Liechtenstein.svg": "d359",
	"./Property 1=4x3, Property 2=LK - Sri Lanka.svg": "5e14",
	"./Property 1=4x3, Property 2=LR - Liberia.svg": "98c9",
	"./Property 1=4x3, Property 2=LS - Lesotho.svg": "0d42",
	"./Property 1=4x3, Property 2=LT - Lithuania.svg": "1b47",
	"./Property 1=4x3, Property 2=LU - Luxembourg.svg": "7bc3",
	"./Property 1=4x3, Property 2=LV - Latvia.svg": "992b",
	"./Property 1=4x3, Property 2=LY - Libya.svg": "5701",
	"./Property 1=4x3, Property 2=MA - Morocco.svg": "bbab",
	"./Property 1=4x3, Property 2=MC - Monaco.svg": "fcf8",
	"./Property 1=4x3, Property 2=MD - Moldova.svg": "f835",
	"./Property 1=4x3, Property 2=ME - Montenegro.svg": "772a",
	"./Property 1=4x3, Property 2=MF - Saint Martin.svg": "d241",
	"./Property 1=4x3, Property 2=MG - Madagascar.svg": "3987",
	"./Property 1=4x3, Property 2=MH - Marshall Islands.svg": "f2eb",
	"./Property 1=4x3, Property 2=MK - North Macedonia.svg": "fa3c",
	"./Property 1=4x3, Property 2=ML - Mali.svg": "147b",
	"./Property 1=4x3, Property 2=MM - Myanmar.svg": "3769",
	"./Property 1=4x3, Property 2=MN - Mongolia.svg": "21ec",
	"./Property 1=4x3, Property 2=MO - Macau.svg": "303a",
	"./Property 1=4x3, Property 2=MP - Northern Mariana Islands.svg": "451d",
	"./Property 1=4x3, Property 2=MQ - Martinique.svg": "ad83",
	"./Property 1=4x3, Property 2=MR - Mauritania.svg": "c982",
	"./Property 1=4x3, Property 2=MS - Montserrat.svg": "9650",
	"./Property 1=4x3, Property 2=MT - Malta.svg": "53c8",
	"./Property 1=4x3, Property 2=MU - Mauritius.svg": "3926",
	"./Property 1=4x3, Property 2=MV - Maldives.svg": "a12a",
	"./Property 1=4x3, Property 2=MW - Malawi.svg": "18da",
	"./Property 1=4x3, Property 2=MX - Mexico.svg": "716e",
	"./Property 1=4x3, Property 2=MY - Malaysia.svg": "e7d9",
	"./Property 1=4x3, Property 2=MZ - Mozambique.svg": "8f6e",
	"./Property 1=4x3, Property 2=NA - Namibia.svg": "40e7",
	"./Property 1=4x3, Property 2=NC - New Caledonia.svg": "ace3",
	"./Property 1=4x3, Property 2=NE - Niger.svg": "756e",
	"./Property 1=4x3, Property 2=NF - Norfolk Island.svg": "6bfe",
	"./Property 1=4x3, Property 2=NG - Nigeria.svg": "bda0",
	"./Property 1=4x3, Property 2=NI - Nicaragua.svg": "2a9c",
	"./Property 1=4x3, Property 2=NL - Netherlands.svg": "8c97",
	"./Property 1=4x3, Property 2=NO - Norway.svg": "e9bb",
	"./Property 1=4x3, Property 2=NP - Nepal.svg": "46fa",
	"./Property 1=4x3, Property 2=NR - Nauru.svg": "9a72",
	"./Property 1=4x3, Property 2=NU - Niue.svg": "c565",
	"./Property 1=4x3, Property 2=NZ - New Zealand.svg": "3d6c",
	"./Property 1=4x3, Property 2=OM - Oman.svg": "bf1c",
	"./Property 1=4x3, Property 2=PA - Panama.svg": "2082",
	"./Property 1=4x3, Property 2=PE - Peru.svg": "c5f9",
	"./Property 1=4x3, Property 2=PF - French Polynesia.svg": "ef13",
	"./Property 1=4x3, Property 2=PG - Papua New Guinea.svg": "811f",
	"./Property 1=4x3, Property 2=PH - Philippines.svg": "464d",
	"./Property 1=4x3, Property 2=PK - Pakistan.svg": "5b6a",
	"./Property 1=4x3, Property 2=PL - Poland.svg": "388c",
	"./Property 1=4x3, Property 2=PM - Saint Pierre and Miquelon.svg": "f370",
	"./Property 1=4x3, Property 2=PN - Pitcairn Islands.svg": "870a",
	"./Property 1=4x3, Property 2=PR - Puerto Rico.svg": "52f0",
	"./Property 1=4x3, Property 2=PS - Palestine.svg": "1428",
	"./Property 1=4x3, Property 2=PT - Portugal.svg": "4445",
	"./Property 1=4x3, Property 2=PW - Palau.svg": "2915",
	"./Property 1=4x3, Property 2=PY - Paraguay.svg": "0833",
	"./Property 1=4x3, Property 2=QA - Qatar.svg": "039d",
	"./Property 1=4x3, Property 2=RE - Reunion.svg": "0766",
	"./Property 1=4x3, Property 2=RO - Romania.svg": "443d",
	"./Property 1=4x3, Property 2=RS - Serbia.svg": "0e40",
	"./Property 1=4x3, Property 2=RU - Russian Federation.svg": "20f9",
	"./Property 1=4x3, Property 2=RW - Rwanda.svg": "07ac4",
	"./Property 1=4x3, Property 2=SA - Saudi Arabia.svg": "f7d6",
	"./Property 1=4x3, Property 2=SB - Solomon Islands.svg": "0cd8",
	"./Property 1=4x3, Property 2=SC - Seychelles.svg": "99df",
	"./Property 1=4x3, Property 2=SD - Sudan.svg": "ac6b",
	"./Property 1=4x3, Property 2=SE - Sweden.svg": "c5ae",
	"./Property 1=4x3, Property 2=SG - Singapore.svg": "d50e",
	"./Property 1=4x3, Property 2=SH - Saint Helena Ascension and Tristan da Cunha.svg": "7c66",
	"./Property 1=4x3, Property 2=SI - Slovenia.svg": "ef65",
	"./Property 1=4x3, Property 2=SJ - Svalbard and Jan Mayen.svg": "c020",
	"./Property 1=4x3, Property 2=SK - Slovakia.svg": "59a5",
	"./Property 1=4x3, Property 2=SL - Sierra Leone.svg": "6ccc9",
	"./Property 1=4x3, Property 2=SM - San Marino.svg": "c01e",
	"./Property 1=4x3, Property 2=SN - Senegal.svg": "9aff",
	"./Property 1=4x3, Property 2=SO - Somalia.svg": "aa2b",
	"./Property 1=4x3, Property 2=SR - Suriname.svg": "5f68",
	"./Property 1=4x3, Property 2=SS - South Sudan.svg": "8713",
	"./Property 1=4x3, Property 2=ST - Sao Tome and Principe.svg": "aa51",
	"./Property 1=4x3, Property 2=SV - El Salvador.svg": "19cb",
	"./Property 1=4x3, Property 2=SX - Sint Maarten.svg": "0ba2",
	"./Property 1=4x3, Property 2=SY - Syria.svg": "1c94",
	"./Property 1=4x3, Property 2=SZ - Eswatini.svg": "a324",
	"./Property 1=4x3, Property 2=TC - Turks and Caicos Islands.svg": "8074",
	"./Property 1=4x3, Property 2=TD - Chad.svg": "756f",
	"./Property 1=4x3, Property 2=TF - French Southern Territories.svg": "dadd",
	"./Property 1=4x3, Property 2=TG - Togo.svg": "0bba",
	"./Property 1=4x3, Property 2=TH - Thailand.svg": "b394",
	"./Property 1=4x3, Property 2=TJ - Tajikistan.svg": "2c16",
	"./Property 1=4x3, Property 2=TK - Tokelau.svg": "f115",
	"./Property 1=4x3, Property 2=TL - East Timor.svg": "5b6f",
	"./Property 1=4x3, Property 2=TM - Turkmenistan.svg": "7f8c",
	"./Property 1=4x3, Property 2=TN - Tunisia.svg": "a2d6",
	"./Property 1=4x3, Property 2=TO - Tonga.svg": "accb",
	"./Property 1=4x3, Property 2=TR - Turkey.svg": "51fd",
	"./Property 1=4x3, Property 2=TT - Trinidad and Tobago.svg": "f42b",
	"./Property 1=4x3, Property 2=TV - Tuvalu.svg": "954f",
	"./Property 1=4x3, Property 2=TW - Taiwan (Republic of China).svg": "a8b7",
	"./Property 1=4x3, Property 2=TZ - Tanzania.svg": "3aef",
	"./Property 1=4x3, Property 2=UA - Ukraine.svg": "86e3",
	"./Property 1=4x3, Property 2=UG - Uganda.svg": "5da2",
	"./Property 1=4x3, Property 2=UM - United States Minor Outlying Islands.svg": "8f68",
	"./Property 1=4x3, Property 2=US - USA.svg": "caf2",
	"./Property 1=4x3, Property 2=UY - Uruguay.svg": "825e",
	"./Property 1=4x3, Property 2=UZ - Uzbekistan.svg": "bd34",
	"./Property 1=4x3, Property 2=VA - Vatican City.svg": "4c60",
	"./Property 1=4x3, Property 2=VC - Saint Vincent and the Grenadines.svg": "66e0",
	"./Property 1=4x3, Property 2=VE - Venezuela.svg": "b991",
	"./Property 1=4x3, Property 2=VG - British Virgin Islands.svg": "9cd2",
	"./Property 1=4x3, Property 2=VI - United States Virgin Islands.svg": "6704",
	"./Property 1=4x3, Property 2=VN - Vietnam.svg": "04c0",
	"./Property 1=4x3, Property 2=VU - Vanuatu.svg": "6bcd",
	"./Property 1=4x3, Property 2=WF - Wallis and Futuna.svg": "3df9",
	"./Property 1=4x3, Property 2=WS - Samoa.svg": "0409",
	"./Property 1=4x3, Property 2=XK - Kosovo.svg": "bb44",
	"./Property 1=4x3, Property 2=YE - Yemen.svg": "431c",
	"./Property 1=4x3, Property 2=YT - Mayotte.svg": "8bc3",
	"./Property 1=4x3, Property 2=ZA - South Africa.svg": "ff58f",
	"./Property 1=4x3, Property 2=ZM - Zambia.svg": "f33b",
	"./Property 1=4x3, Property 2=ZW - Zimbabwe.svg": "cece",
	"./Property 1=4x3, Property 2=cn - China.svg": "7a19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2e92";